export const Events = Object.freeze({
	Click: 'click',
	Popstate: 'popstate',
	Keydown: 'keydown',
	Keyup: 'keyup',
	Blur: 'blur',
	Change: 'change'
});
